import React, { useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './WhatsTrendingCarousel.scss';
import playButton from '../../../../assets/smartxonnect/play.webp';

const WhatsTrendingCarousel = (props) => {
  const [playingVideoId, setPlayingVideoId] = useState(null);
  const [centeredSlide, setCenteredSlide] = useState(0);

  const settings = {
    dots: true,
    centerMode: true,
    centerPadding: '0px',
    slidesToShow: 3,
    infinite: true,
    speed: 500,
    beforeChange: (current, next) => {
      setCenteredSlide(next);
      setPlayingVideoId(null);
    },
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '60px',
          slidesToShow: 1,
        },
      },
    ],
  };

  const handleCardClick = (id, index) => {
    if (centeredSlide === index) {
      setPlayingVideoId(id);
    }
  };

  return (
    <div className="carousel-container" data-aos="fade-up">
      <div className="header-section">
        <h2 className="trending-header roboto-bold">What&rsquo;s Trending</h2>
      </div>
      <Slider {...settings}>
        {props?.fields?.CarouselCards?.map((card, index) => (
          <div
            key={card.id}
            className="carousel-slide"
            onClick={() => card.fields.IsVideo.value && handleCardClick(card.id, index)}
          >
            {card.fields.IsVideo.value ? (
              playingVideoId === card.id ? (
                <iframe
                  src={`${card.fields.CardCTA.value.href}?autoplay=1`}
                  title={card.fields.CardTitle.value}
                  width="100%"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              ) : (
                <>
                  <img
                    src={`${card.fields.CardMedia.value.src}`}
                    alt={card.fields.CardMedia.value.alt}
                  />
                  <div className="play-button">
                    <img src={playButton} alt="Play Video" />
                  </div>
                </>
              )
            ) : (
              <img
                src={`${card.fields.CardMedia.value.src}`}
                alt={card.fields.CardMedia.value.alt}
              />
            )}
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default WhatsTrendingCarousel;
